import * as React from 'react';

import { ScammerAlert } from '../../components/ScammerAlert';
import { useApplicationContext } from '../../utils/applicationContext';

export const ScammerAlertContainer = () => {
  const { config } = useApplicationContext();
  const isScammerAlertShown = config.get<boolean>('frontend-chats.scammerAlert.Enabled') || false;

  if (!isScammerAlertShown) {
    return null;
  }

  return <ScammerAlert />;
};
